import StarFilled20 from '@carbon/icons-react/es/star--filled/20';
// eslint-disable-next-line no-restricted-imports
import { Rate as AntRate } from 'antd';
import { RateProps } from 'antd/es/rate';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

const CustomRate = styled(AntRate)<RateProps>`
  & {
    color: var(--yellow-50);
  }

  ${ifProp(
    'disabled',
    css`
      .ant-rate-star:not(:last-child) {
        margin-right: var(--spacing-02);
      }
    `,
  )};
`;

export const Rate: FC<RateProps> = (props) => (
  <CustomRate character={<StarFilled20 />} allowHalf {...props} />
);
